{
  "longPressMessage": "長押しまたは Alt+下矢印キーでメニューを開く"
}
